<template>
  <WhitePage>
    <title-bar>ゲームルール</title-bar>
    <!-- <help-nav></help-nav> -->
    <h3>ゲームスタート<div class="subtitle">とりあえず散歩とにかく散歩</div></h3>
    <p>
      ゲーム開始時、キャラクターはランダムに振り分けられたエリアに飛ばされます。
      <span class="highlight">そのエリアでやることを１つ選択し、移動したい場合は移動先の行動宣言をしてください。</span>基本の行動宣言はこれだけです。
    </p>
    <p>
      ゲーム初日は「散歩する」しか選択肢がありませんので、潔く散歩しましょう。
      何も選択しなかった場合は何もしません。
    </p>
    <p>
      行動の選択肢を見ると、詳細の欄に行動内容の記載があります。
      各行動はミニゲームのように成功・失敗があり、結果に応じて報酬を得ます。
      キャラクターにはステータスがあり、成功した場合はステータスが少し増えます。
    </p>
    <p>
      ステータスが一定値に達すると、移動可能なエリアの選択肢が増えます。
      そのようなエリアは、レベルが少し高くなり、各行動の難易度が上がります。
      いろんな場所に行くためには、いろんなステータスを伸ばす必要があります。
    </p>
    <p>
      とはいえ、<span class="highlight">このゲームにはクリアは特にありません。</span>
      楽しみ方はキャラクターの自由です。
      散歩するだけもよし、全てのエリアを旅するもよし、ステータスを伸ばすもよし、
      気が向いたときに行動してみてください。
    </p>
    <p>
      注意書きにも述べた通り、運営の砂場なので、何が起こるかわかりません。
    </p>
    <h3>キャラクター<div class="subtitle">ステータスは飾り</div></h3>
    <p>
      キャラクターはステータスを持ちます。が、ほとんどはそれ自体には効果はありません。
      ステータスは行動の成功率を高めます。エリアの移動に必要な時があります。
    </p>
    <b-table-simple bordered small>
      <b-thead>
        <b-tr>
          <b-th style="width:200px">名前</b-th>
          <b-th>効果</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr>
          <b-td>EP</b-td><b-td>イベントポイント。消費してイベントを作ることができます。</b-td>
        </b-tr>
        <b-tr>
          <b-td>STR</b-td><b-td>強さ</b-td>
        </b-tr>
        <b-tr>
          <b-td>INT</b-td><b-td>賢さ</b-td>
        </b-tr>
        <b-tr>
          <b-td>VIT</b-td><b-td>活力</b-td>
        </b-tr>
        <b-tr>
          <b-td>MND</b-td><b-td>精神</b-td>
        </b-tr>
        <b-tr>
          <b-td>DEX</b-td><b-td>器用さ</b-td>
        </b-tr>
        <b-tr>
          <b-td>AGI</b-td><b-td>敏捷性</b-td>
        </b-tr>
        <b-tr>
          <b-td>HP</b-td><b-td>体力</b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
    <h3>行動<div class="subtitle">まだ少ないけども</div></h3>
    <p>
      行動には、エリアが最初から用意している固定のメイン行動（散歩のような）と、
      誰かが作成したカスタム行動の２種類あります。
    </p>
    <p>
      行動は更新ごとに１つだけ実行します。
      メイン行動またはカスタム行動から選択します。
    </p>
    <b-table-simple bordered>
      <b-thead>
        <b-tr>
          <b-th style="width:200px">ルール名</b-th>
          <b-th>内容</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr>
          <b-td><b>【ダイスロール】</b></b-td>
          <b-td>
            <p>
              行動の成否を判定します。
            </p>
            <p>
              2d6(６面ダイスを２個)を振ります。
              「結果値＋特定ステータス」が目標値以上で成功、目標値未満で失敗です。
            </p>
            <p>
              成功するとステータスが１増えます。目標値はエリアレベルにも依存します。
            </p>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td><b>【ダイスショット】</b></b-td>
          <b-td>
            <p>
              NPCとダイス目で勝負します。
            </p>
            <p>
              「技」と「見切り」を選択し、2d6(６面ダイスを２個)を振ります。
              「結果値＋技が依存するステータス」が相手の出目以上で成功、出目未満で失敗です。
              相手の技が見切りと同じ場合、技が依存するステータスの分を打ち消すことができます。
            </p>
            <p>
              成功するとステータスが１増えます。目標値はエリアレベルにも依存します。
            </p>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
    <p>
      カスタム行動は「EP」ステータスを１消費して作成することができます。
      EPは散歩すると増えますが、カスタム行動で増やすこともできます。
    </p>
    <h3>エリア<div class="subtitle">メインエリアとスポット</div></h3>
    <p>
      エリアはキャラクターが滞在する場所です。
      エリアごとに行動できることが変わります。
      また、エリア同士は道を持ち、道が繋がっているエリアに移動することができます。
    </p>
    <p>
      エリアには２種類、メインエリアとスポットが存在します。
    </p>
    <b-table-simple bordered>
      <b-thead>
        <b-tr>
          <b-th style="width:200px">種類</b-th>
          <b-th>詳細</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr>
          <b-td>メインエリア</b-td>
          <b-td>
            基本のエリアです。
            <ul>
              <li>各メインエリアで行動可能なイベントを作ることができます。</li>
              <li>他のメインエリアと、そのメインエリアで作られたスポットと繋がっています。</li>
            </ul>
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>スポット</b-td>
          <b-td>
            キャラクターが作成可能なエリアです。世界ごとに１つだけ作ることができます。
            <ul>
              <li>メインエリア上で、メインエリアに繋がるスポットを作ることができます。
                つまり、スポット上で別のスポットを繋げることはできません。</li>
              <li>各スポットで行動可能なイベントを作ることができます。</li>
              <li>スポットの作成者は、イベントの作成を制限することができます。</li>
              <li>スポット上は、隣接しているメインエリアの行動を実行することができます。
                その場合、メインエリア上の行動になります。</li>
            </ul>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
    <p>
      メインエリア同士の道には、特定ステータスが一定以上でないと通ることができない通行条件が設定されている場合があります。
      通行条件を満たしていない道は非表示です。
      たとえば、１つのエリアに進むための道が複数あって、そのいずれにも通行条件が設定されている場合、
      キャラクターのステータスに適した道から移動する必要があります。
    </p>
    <h3>異世界<div class="subtitle">まるで定期ゲームツ○ール</div></h3>
    <p>
      プレイヤーは異世界を作ることができます。
      異世界に好きなエリアを配置し、好きなクエストを置いて、簡素な定期ゲームを運営します。
    </p>
    <ul>
      <li>異世界は今のところ１つ作成することができます。</li>
      <li>作成された異世界に入ると、キャラクターのステータスはその異世界の法則に従って変換されます。
        この時のステータスは、元の世界でのステータスとは独立して成長します。</li>
      <li>異世界の入口はスポットで設定します。</li>
      <li>異世界の出口は不奇跡世界に繋がりますが、ランダムに飛ばされます。</li>
    </ul>
    <pagenate>
      <template #previous>
        <b-icon icon="chevron-left" />
        <router-link to="/help">はじめに</router-link>
      </template>
      <template #next>
        <router-link to="/help/etc">その他</router-link>
        <b-icon icon="chevron-right" />
      </template>
    </pagenate>
  </WhitePage>
</template>

<script>
// import phina from 'phina.js'
import WhitePage from '@/components/WhitePage'
import TitleBar from '@/components/TitleBar'
// import HelpNav from '@/components/HelpNav'
import Pagenate from '@/components/Pagenate'
export default {
  components: {
    WhitePage,
    TitleBar,
    // HelpNav
    Pagenate
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
    // phina.global.app.currentScene.exit('MainScene')
  }
}
</script>

<style scoped lang="scss">
h3 {
  margin: 2rem 10px 1.5rem;

  .subtitle {
    font-size: small;
    margin-left: 10px;
  }

}
p {
  margin: 0 10px 1rem;
}
.highlight {
  color: rgb(144, 24, 20);
}
</style>
